import React from 'react';
import Form from '@grnhse/seedling/lib/birch/components/forms/form';
import type { MyGreenhouseProps } from 'talent_matching/types';
import { MyGreenhouseTabContextProvider } from 'talent_matching/contexts/my_greenhouse_tab_context';
import MyGreenhousePageContent from 'talent_matching/my_greenhouse/my_greenhouse_page_content';
import { MY_GREENHOUSE_DEFAULT_VALUES } from 'talent_matching/my_greenhouse/my_greenhouse_default_values';
import noop from 'lodash/noop';

const MyGreenhouseDiscovery = (myGreenhouseProps: MyGreenhouseProps) => {
  return (
    <MyGreenhouseTabContextProvider myGreenhouseProps={myGreenhouseProps}>
      <Form
        defaultValues={MY_GREENHOUSE_DEFAULT_VALUES}
        onSubmit={noop}
        submitMode="preserve"
      >
        <MyGreenhousePageContent defaultValues={MY_GREENHOUSE_DEFAULT_VALUES} />
      </Form>
    </MyGreenhouseTabContextProvider>
  );
};

export default MyGreenhouseDiscovery;
